import { apiGet, apiPost } from '../../../components/qv4/models/shared/apiClient';
const root = '/messaging-v1/business-sends';
const unwrap = response => {
  if (response?.data?.success !== true || !response.data.data) {
    throw Object.assign(new Error(response?.data?.error?.message || response?.data?.message || 'Unable to read business-send state.'), { response });
  }
  return response.data.data;
};
export const listBusinessSends = conversationId => apiGet(`${root}?${new URLSearchParams({ conversation_id: conversationId })}`).then(unwrap).then(data => {
  if (!Array.isArray(data.rows)) throw new Error('The discovery response is invalid. No sends have been resolved.');
  return data;
});
export const getBusinessResolution = id => apiGet(`${root}/${encodeURIComponent(id)}/resolution`).then(unwrap);
export const resolveBusinessSend = (id, body, key) => apiPost(`${root}/${encodeURIComponent(id)}/resolutions`, body, { headers: { 'Idempotency-Key': key } }).then(unwrap);
export const isOperationId = id => /^op_[a-f0-9]{32}$/.test(id || '');
export const operationTypes = ['query_direct_quote', 'quote_approval_text', 'delivery_otp'];
export function validResolution(row) {
  return isOperationId(row?.operation_id) && operationTypes.includes(row.operation_type)
    && /^con_[a-f0-9]{32}$/.test(row.conversation_id || '') && Number.isSafeInteger(Number(row.actor_user_id)) && Number(row.actor_user_id) > 0
    && row.fence_released === true && ['delivered', 'not_delivered'].includes(row.resolution?.outcome)
    && row.status === (row.resolution.outcome === 'delivered' ? 'submitted' : 'failed')
    && Number.isFinite(Date.parse(row.resolution.resolved_at));
}
